import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TableSortLabel, useTheme } from "@mui/material";
import React, { Fragment, useCallback, useEffect, useState } from "react";
import { ErrorAlert } from "../ErrorAlert";
import { UndrawEmpty } from "../content-table/UndrawEmpty";
const defaultPageSizes = [10, 25, 50, 100];
export function DataTable(props) {
    const { columns, rows, onSort, sortDirection, sortField, loading, error, rowId = "id", empty = React.createElement(UndrawEmpty, { height: "100%", width: "auto" }), page, onPageChange, pageSizes = defaultPageSizes, header, toolbar, } = props;
    const theme = useTheme();
    // reset page index to `0` if it is out of bounds
    // this can happen when a filter changes and the result set becomes smaller
    useEffect(() => {
        if (page && onPageChange) {
            const { pageIndex, pageSize, totalElements } = page;
            const totalPages = Math.ceil(totalElements / pageSize);
            if (pageIndex >= totalPages) {
                onPageChange(Object.assign(Object.assign({}, page), { pageIndex: 0 }));
            }
        }
    }, [page, onPageChange]);
    // When loading
    const [displayRows, setDisplayRows] = useState(rows);
    useEffect(() => {
        if (!loading || rows.length > 0) {
            setDisplayRows(rows);
        }
    }, [rows, loading]);
    function handlePageChange(event, pageIndex) {
        if (page && onPageChange) {
            onPageChange(Object.assign(Object.assign({}, page), { pageIndex }));
        }
    }
    function handleRowsPerPageChange(event) {
        const pageSize = Number.parseInt(event.target.value);
        if (page && onPageChange) {
            onPageChange(Object.assign(Object.assign({}, page), { pageSize }));
        }
    }
    const pagination = page && (React.createElement(TablePagination, { component: "div", rowsPerPageOptions: pageSizes, count: page.totalElements, rowsPerPage: page.pageSize, page: page.pageIndex, onPageChange: handlePageChange, onRowsPerPageChange: handleRowsPerPageChange }));
    return (React.createElement(Paper, null,
        header,
        React.createElement(TableContainer, null,
            React.createElement(Table, null,
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null, columns.map(column => (React.createElement(DataTableHeaderCell, { key: column.field, column: column, sortField: sortField, sortDirection: sortDirection, onSort: onSort }))))),
                React.createElement(TableBody, { sx: { minHeight: "100px", opacity: loading ? 0.5 : undefined } },
                    error && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: columns.length },
                            React.createElement(ErrorAlert, { error: error })))),
                    !error && !loading && rows.length == 0 && (React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: columns.length },
                            React.createElement(Box, { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", p: 3 },
                                React.createElement(Box, { sx: {
                                        height: 300,
                                        [theme.breakpoints.down('md')]: {
                                            height: 150
                                        },
                                    } }, empty))))),
                    displayRows.map(row => {
                        const id = row[rowId];
                        return (React.createElement(TableRow, { key: id }, columns.map(({ field, component, align }) => {
                            const Component = component !== null && component !== void 0 ? component : DefaultDataTableCell;
                            return (React.createElement(TableCell, { key: field, align: align },
                                React.createElement(Component, { row: row, field: field })));
                        })));
                    })))),
        toolbar && pagination && (React.createElement(Box, { display: "flex", justifyContent: "space-between" },
            toolbar,
            pagination)),
        !pagination && toolbar,
        !toolbar && pagination));
}
export function DefaultDataTableCell({ row, field }) {
    const value = row[field];
    if (typeof value == "string" || typeof value == "number") {
        return React.createElement(Fragment, null, value);
    }
    return null;
}
function DataTableHeaderCell(props) {
    const { column, sortField, sortDirection, onSort } = props;
    const handleClick = useCallback(() => column.sortable && onSort && onSort(column.field), [onSort, column]);
    return (React.createElement(TableCell, { style: { width: column.width }, align: column.align }, column.sortable
        ? (React.createElement(TableSortLabel, { active: sortField == column.field, direction: sortDirection || undefined, onClick: handleClick }, column.label))
        : column.label));
}
//# sourceMappingURL=DataTable.js.map